'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBellSolidCircle, iconBellSolidCircleTag } from '@ni/nimble-components/dist/esm/icons/bell-solid-circle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBellSolidCircle };
export { iconBellSolidCircleTag };
export const NimbleIconBellSolidCircle = wrap(IconBellSolidCircle);